
import { defineComponent } from 'vue';
import { useCurrencyQuote } from '@/composables/useCurrencyQuote';

export default defineComponent({
  setup() {
    const { currencyQuote, CURRENCIES } = useCurrencyQuote();
    return { currencyQuote, CURRENCIES };
  },
});
